const MOCK_WORKERS = [
    {
        id: '1',
        name: 'CV Reader',
        tag: 'cvReader',
        description: 'Read CV',
        jsonSchema: "{\n" +
            "  \"firstname\": \"Jan\",\n" +
            "  \"lastname\": \"Kowalski\",\n" +
            "  \"email\": \"jan.kowalski@example.com\",\n" +
            "  \"phone\": \"+48 500 600 700\",\n" +
            "  \"address\": \"ul. Marszalkowska 10/5, 00-001 Warszawa, Polska\",\n" +
            "  \"nationality\": \"Polish\",\n" +
            "  \"languages\": [\n" +
            "    \"Polish\",\n" +
            "    \"English\",\n" +
            "    \"German\"\n" +
            "  ],\n" +
            "  \"driving_license\": \"yes\",\n" +
            "  \"title\": \"Senior Python Developer\",\n" +
            "  \"summary\": \"Doswiadczony programista Python z 8-letnim stazem w tworzeniu aplikacji webowych i systemow backendowych.\",\n" +
            "  \"document_summary\": \"Kandydat posiada mocne doswiadczenie w Pythonie, Django, API i pracy z bazami danych.\",\n" +
            "  \"skills\": [\n" +
            "    \"Python\",\n" +
            "    \"Django\",\n" +
            "    \"FastAPI\",\n" +
            "    \"PostgreSQL\",\n" +
            "    \"Docker\",\n" +
            "    \"Git\"\n" +
            "  ],\n" +
            "  \"experience\": [\n" +
            "    {\n" +
            "      \"company\": \"Tech Solutions Sp. z o.o.\",\n" +
            "      \"position\": \"Senior Python Developer\",\n" +
            "      \"start_date\": \"2021-05\",\n" +
            "      \"end_date\": \"2025-02\",\n" +
            "      \"description\": \"Rozwoj i utrzymanie systemow backendowych oraz integracji API.\"\n" +
            "    },\n" +
            "    {\n" +
            "      \"company\": \"Code Factory\",\n" +
            "      \"position\": \"Python Developer\",\n" +
            "      \"start_date\": \"2018-01\",\n" +
            "      \"end_date\": \"2021-04\",\n" +
            "      \"description\": \"Tworzenie aplikacji webowych i automatyzacja procesow biznesowych.\"\n" +
            "    }\n" +
            "  ]\n" +
            "}",
        mappings: { orderId: 'order_id', status: 'order_status', 'customer.firstName': 'customer_first_name', 'customer.lastName': 'customer_last_name', 'customer.email': 'customer_email', total: 'order_total', 'items.name': 'item_name' },
    },
    {
        id: '2',
        name: 'ID Reader',
        tag: 'idReader',
        description: 'Read ID',
        jsonSchema: "{\n" +
            "  \"document_number\": \"ABC123456\",\n" +
            "  \"firstname\": \"Jan\",\n" +
            "  \"lastname\": \"Kowalski\",\n" +
            "  \"personal_number\": \"90010112345\",\n" +
            "  \"birth_date\": \"1990-01-01\",\n" +
            "  \"nationality\": \"polskie\",\n" +
            "  \"permit_type\": \"karta pobytu czasowego\",\n" +
            "  \"sex\": \"M\",\n" +
            "  \"address\": \"ul. Marszalkowska 10/5, 00-001 Warszawa, Polska\"\n" +
            "}",
        mappings: { id: 'user_id', username: 'user_login', email: 'user_email', 'profile.firstName': 'first_name', 'profile.lastName': 'last_name', 'profile.age': 'age' },
    },
    {
        id: '3',
        name: 'SSN Reader',
        tag: 'ssnReader',
        description: 'Read SSN',
        jsonSchema: "{\n" +
            "  \"ssn_number\": \"123-45-6789\",\n" +
            "  \"ssn_number_digits\": \"123456789\"\n" +
            "}",
        mappings: {},
    },

];

const getList = () => Promise.resolve([...MOCK_WORKERS]);
const getById = (id) => Promise.resolve(MOCK_WORKERS.find(w => w.id === id));
const create = (worker) => Promise.resolve({ ...worker, id: crypto.randomUUID() });
const update = (worker) => Promise.resolve(worker);
const remove = (id) => Promise.resolve();

export default { getList, getById, create, update, remove };
